<template>
  <div class="case_box">
    <!-- <Header @name="updateTitle($event)"></Header> -->
    <div class="case">
      <b-container>
        <p class="return" @click="Back">
          < 返回案例首页</p> <div class="box1">
            <h1>案例展示</h1>
            <p>—CASE—</p>
            <span>最专业的品牌服务 为您创作更高的价值
            </span>
    </div>
    <div class="case_box2 row">
      <div class="case_box3 col-4" v-for="(item,index) in data" :key="index">
        <div class="pox" @mouseover="selectStyle (item) " @mouseout="outStyle(item)">
          <img :src="item.navigation" class="case_img">

          <div class="active" v-show="item.active">
            <b-row>
              <b-col v-show="item.ios_url"><img :src="item.ios_url" class="img">
                <p>- IOS下载 -</p>
              </b-col>
              <b-col v-show="item.android_url"><img :src="item.android_url" class="img">
                <p>- 安卓下载 -</p>
              </b-col>
            </b-row>
            <b-button variant="outline-light" size="sm" pill class="btn" @click="look(item)">查看详情</b-button>
          </div>
        </div>
        <p>
          {{item.name}}</p>
        <span>{{item.intro}}</span>
      </div>

    </div>
    </b-container>
  </div>
  <!-- <Footer></Footer> -->
  </div>
</template>

<script>
  import Header from "@/components/header.vue";
  import Footer from "@/components/footer.vue";
  import axios from 'axios'
  import local from '../utils/local'

  export default {
    components: {
      Header,
      Footer,
    },
    data() {
      return {
        active: false,
        data: []
      };
    },
    created() {
      this.getInfo();
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    mounted() {},
    methods: {
      getInfo() {
        axios.post('http://api1.home.didigo.es/admin/admin/index').then(res => {
            this.data = res.data.data.instance;
        })

      },
      Back() {
        this.$router.push('/home')
      },
      selectStyle(item) {
        // item.active=true;
        var _this = this;
        this.$nextTick(function () {
          this.data.forEach(function (item) {
            _this.$set(item, 'active', false);
          });
          this.$set(item, 'active', true);
        });
      },
      outStyle(item) {
        this.$set(item, 'active', false);
      },
      look(data) {
        // console.log(111)
        this.$router.push({
          path: `/details`,
          query: {
            data: JSON.stringify(data),
          }
        });
      }

    }
  };
</script>

<style lang="less">
  .box1 {
    text-align: center;
    margin-top: 80px;

    h1 {
      font-size: 24px;
      font-weight: bold;
      color: #333;
    }

    p {
      font-size: 14px;
      color: #666;
      margin-bottom: 10px;
    }

    span {
      color: #808080;
      font-size: 16px;
    }
  }

  .case_box {
    position: relative;

  }

  .case {

    padding-top: 80px;

    .return {
      font-size: 14px;
      color: #666;
      margin-top: 40px;
    }

    .case_box2 {
      margin-bottom: 50px;
      width: 100%;

      .col-4 {
        padding: 0;
      }

      .case_box3 {
        // width: 300px;
        margin-top: 80px;
        text-align: center;

        p {
          font-size: 16px;
          color: #333;
          line-height: 45px;
          margin: 0;
        }

        .pox {
          position: relative;
          width: 320px;
          height: 240px;

          .case_img {
            width: 320px;
            height: 240px;
          }

          .active {
            width: 100%;
            height: 240px;
            position: absolute;
            padding: 30px 10px;
            background: rgba(0, 0, 0, 0.5) !important;
            top: 0;
            left: 0;
            margin: 0;

            .col {
              text-align: center;

              p {
                color: #fff;
                z-index: 100;
              }

              .img {
                width: 110px;
                height: 110px;
              }


            }

            .btn {
              width: 120px;
              
            }
          }
        }

        span {
          font-size: 12px;
          color: #999;

        }
      }

    }

    .look {
      width: 100%;
      text-align: center;
      color: #28a6fc;
      font-size: 14px;
    }


  }
</style>